import { t } from 'i18next'

export enum TerminateSuggestionAction {
  IN_EFFECT = 'in_effect',
  TERMINATE = 'terminate',
  PENDING = 'pending',
}

export interface TerminateSuggestion {
  id: TerminateSuggestionAction
  label: string
  disabled: boolean
}

export const useTerminateSuggestions = () => ({
  terminateSuggestions: [
    {
      id: TerminateSuggestionAction.IN_EFFECT,
      label: t('terminateContract:terminateSuggestions.inEffect'),
      disabled: false,
    },
    {
      id: TerminateSuggestionAction.TERMINATE,
      label: t('terminateContract:terminateSuggestions.terminate'),
      disabled: false,
    },
  ],
})
